import React, { FC, useRef, useState, Suspense } from 'react';
import { Text, Box, Checkbox, AvatarSize, Icon, IconSize } from '@bechtel/gds';
import { CraftListItemProps } from './types';
import { CrewMember } from '@bechtel/types';
import { findIndex, some } from 'lodash';
import { ListSelectionStyled, CraftHeaderStyled } from './styled';
import { CrewChangeRequestPopover } from '../../pop-over';
import { AvatarRegularStyled } from '../../styled';
import { useName, SuspenseLoader } from '@bechtel/client-common';

export const CraftListItem: FC<CraftListItemProps> = ({
  craftItem,
  selectedCrafts,
  onCraftSelect,
  moveEntireCrew,
  hasPendingEntireCrewChangeRequest,
}) => {
  const { getFullName } = useName();
  const [showRequestInProgress, setShowRequestInProgress] = useState<boolean>(false);
  const refElement = useRef(null);
  const hasPendingCrewChangeRequest = craftItem?.hasPendingCrewChangeRequest || hasPendingEntireCrewChangeRequest;

  return (
    <ListSelectionStyled
      moveEntireCrew={moveEntireCrew}
      hasPendingCrewChangeRequest={hasPendingCrewChangeRequest}
      data-testid={`craft-list-item-${craftItem.id}`}
      key={craftItem.id}
      onClick={() => {
        if (hasPendingCrewChangeRequest || moveEntireCrew) return;
        const selectedCraftsCopy = [...selectedCrafts];
        const selected = findIndex(selectedCraftsCopy, (selectedItem) => {
          return selectedItem.id === craftItem.id;
        });
        if (selected !== -1) {
          selectedCraftsCopy.splice(selected, 1);
        } else {
          selectedCraftsCopy.push(craftItem);
        }
        onCraftSelect([...selectedCraftsCopy]);
      }}
    >
      <Box alignItems={{ sm: 'center' }}>
        {!hasPendingEntireCrewChangeRequest && (
          <Box
            mr={{ sm: '600' }}
            css={moveEntireCrew || hasPendingCrewChangeRequest ? 'opacity:0.5; pointer-events:none' : ''}
          >
            <Checkbox
              checked={some(selectedCrafts, (selectedItem: CrewMember) => {
                return selectedItem.id === craftItem.id;
              })}
              readOnly
            />
          </Box>
        )}
        <Box mr={{ sm: '500' }} css={hasPendingCrewChangeRequest ? 'opacity:0.5; pointer-events:none' : ''}>
          <AvatarRegularStyled
            hasImageUrl={craftItem && craftItem.imageUrl ? true : false}
            size={AvatarSize.MEDIUM}
            src={craftItem && craftItem.imageUrl ? craftItem.imageUrl : undefined}
          />
        </Box>
        <Box
          flexDirection={{ sm: 'column' }}
          css={hasPendingCrewChangeRequest ? 'opacity:0.5; pointer-events:none' : ''}
        >
          <CraftHeaderStyled>{getFullName(craftItem.firstName, craftItem.lastName)}</CraftHeaderStyled>
          <Text size="300" color="grey.600">
            {craftItem.subGroupDescription}
          </Text>
        </Box>
      </Box>
      {!hasPendingEntireCrewChangeRequest && craftItem?.hasPendingCrewChangeRequest && (
        <Icon
          onMouseEnter={() => setShowRequestInProgress(true)}
          onMouseLeave={() => setShowRequestInProgress(false)}
          ref={refElement}
          size={IconSize.MEDIUM}
          icon="info-circle"
          style={{ cursor: 'pointer' }}
          fillColor="blue.800"
        ></Icon>
      )}
      {refElement && showRequestInProgress && (
        <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
          <CrewChangeRequestPopover showPopper={showRequestInProgress} refElement={refElement} />
        </Suspense>
      )}
    </ListSelectionStyled>
  );
};

export default CraftListItem;
